import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_BASE_URL || 'https://api.example.com/api/v1';

const client = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => {
    // Auto-unwrap Worker envelope: { data: { ... } } → { ... }
    if (
      res.data &&
      typeof res.data === 'object' &&
      'data' in res.data &&
      Object.keys(res.data).length === 1
    ) {
      res.data = res.data.data;
    }
    return res;
  },
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('jwt_token');
      window.location.hash = '#/';
    }
    return Promise.reject(err);
  }
);

export default client;
